export { merchantActivationFetchSettingsAction, reducer, saga } from './duck';
